module.exports = __webpack_public_path__ + "img/NASUSD.114d81b8.png";